// Postgres rows omit disk-only `local:` cybos, so a missing cybo proves nothing until one deadline per selection.
export const cyboRosterMirror = $state({ provisional: false, mirrorOnly: false });

const postgresOnlyAnswers = new WeakSet<readonly unknown[]>();
let waitOver = false;

export function markMirrorOnlyCybos<T extends readonly unknown[]>(list: T): T {
  postgresOnlyAnswers.add(list);
  return list;
}

export function noteCyboAnswer(list: readonly unknown[]): void {
  const postgresOnly = postgresOnlyAnswers.has(list);
  cyboRosterMirror.provisional = postgresOnly && !waitOver;
  cyboRosterMirror.mirrorOnly = postgresOnly;
}

export function beginCyboWait(): void {
  waitOver = false;
  cyboRosterMirror.provisional = false;
  cyboRosterMirror.mirrorOnly = false;
}

export function endCyboWait(): void {
  waitOver = true;
  cyboRosterMirror.provisional = false;
}
